import React, { useEffect, useRef } from 'react';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros';
import { ContenedorTabla } from '../../components/utils/ContenedorTabla';
import { useSugerencias } from '../../../hooks/useSugerencias';
import { SearchTable } from '../../components/utils/SearchTable';
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { notify, primeraLetraMayuscula } from '../../../utils/utils';
import { useModal } from '../../../hooks/useModal';
import { Modal } from '../../components/modal/Modal';
export const BuzonSugerencias =()=>{
    const {quejas, listarQuejas, atenderQueja, editarValorQueja, queja} = useSugerencias();
    const idTablaSugerencia = "tablaSugerencia"
    const classNameInput = "text-white h-[30px] rounded px-4 w-full bg-zinc-900 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
    const [ isOpenModalAtender, openModalAtender, closeModalAtender ] = useModal();
    const txtComentario = useRef(null)
    useEffect(() => {
        listarQuejas();
    }, []);

    const obtenerEstado = (codEstado, nomEstado) => {
        let color = '';
        switch(codEstado){
            case 9: // Pendiente
                color = 'bg-yellow-500';
            break;
            case 18: // Atendido
                color = 'bg-green-500';
            break;
            
            default: // 
                color = 'bg-blue-500';
            break
        }
        return <span className={`${color} w-[80px] min-w-[80px] text-center px-2 rounded lg: text-xs`}>{primeraLetraMayuscula(nomEstado)}</span>
    }

    const registrarAtenderQueja = async () => {
        if(queja.comentarioSugerencia.trim() === ''){
            txtComentario.current.focus()
            notify('El comentario es obligatorio', 'error');
            return;
        }
        const isValid = await atenderQueja();
        if(isValid){
            closeModalAtender();
            await listarQuejas();
        }
    }

    return(
    <>
        <ContenedorParametros titulo="Buzón de sugerencia">
            <BotonProcesar onClick={listarQuejas}></BotonProcesar>
            <SearchTable tablaId={idTablaSugerencia}></SearchTable>
        </ContenedorParametros>
        <ContenedorTabla>
            <table id={idTablaSugerencia} className="table ">
                <thead>
                    <tr key={'filaCabecera'}>
                        <th className="w-[30px]">N</th>
                        <th className="text-center">NOMBRE</th>
                        <th className="text-center">COMENTARIO SUGERENCIA</th>
                        <th className="text-center">COMENTARIO ATENCIÓN</th>
                        <th className="text-center">FECHA ATENCIÓN</th>
                        <th className="text-center">UID ATENCIÓN</th>
                        <th className="text-center">ESTADO</th>
                        <th className="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    {   quejas.length > 0 ?
                            quejas.map((queja , i)=>(
                                <tr key={i+1}>
                                    <td>{i+1}</td>
                                    <td className="text-left">{queja.nomPersona}</td>
                                    <td className="text-center w-[300px] max-w-[350px]" title={queja.comentarioSugerencia}>
                                        <div className="w-[98%] text-ellipsis overflow-hidden whitespace-nowrap">{queja.comentarioSugerencia}</div>
                                    </td>
                                    <td className="text-center w-[300px] max-w-[350px]">
                                        <div className="w-[98%] text-ellipsis overflow-hidden whitespace-nowrap">{queja.comentarioAtencion}</div>
                                    </td>
                                    <td className="text-left">{queja.fechaAtencion}</td>
                                    <td className="text-left">{queja.uidAtencion}</td>
                                    <td className='text-center'>{obtenerEstado(queja.codEstado, queja.nomEstado)}</td>
                                    <td className='text-center'>
                                        {
                                            queja.codEstado === 18 ?
                                                <></>
                                            :
                                                <button
                                                    className="px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors duration-300"
                                                    onClick={() => {
                                                        editarValorQueja("comentarioAtencion", "");
                                                        // editarValorQueja("uidAtencion", queja.uidAtencion || '');
                                                        editarValorQueja("codSugerencia", queja.codSugerencia);
                                                        openModalAtender();
                                                    }}
                                                >
                                                    <i className="fa-solid fa-user-clock"></i>
                                                </button>
                                        }
                                    </td>
                                </tr>
                            ))
                        :
                        <tr><td colSpan={8} className='text-center'>No hay información con los parametros seleccinados...</td></tr>
                    }
                </tbody>
            </table>
        </ContenedorTabla>
        <Modal
            title={`Atender sugerencia [ ${queja.nomPersona} ]`}
            isOpen={isOpenModalAtender}
            closeModal={closeModalAtender}
            action={() => registrarAtenderQueja()}
            textButtons={{ confirm: 'Si', denied:'No'}}
            validButton={{confirm: true, denied: true}}
        >
            <div className='flex flex-col items-center gap-2 py-3 w-full'>
                <img
                    src='https://upload.wikimedia.org/wikipedia/commons/1/11/Blue_question_mark_icon.svg'
                    className='w-[40px] h-[40px]'
                    alt=''
                />
                <span className='text-lg'>¿Está seguro de realizar la operación ?</span>
                <span className='float-left w-full'>Comentario:</span>
                <textarea
                    ref={txtComentario}
                    className={classNameInput + ' h-[200px] caret-white py-2'}
                    value={queja.comentarioSugerencia}
                    onChange={(e) => editarValorQueja("comentarioAtencion", e.target.value)}
                ></textarea>
            </div>
        </Modal>
    </>
    
    
    )
    
    
}